import { Divider } from "@mui/material"
import { AI_DISCLAIMER } from "helpers/ai"
import { useMessagesContext } from "../../hooks/context"
import AiTeammateFetchingProgress from "../fetching-progress"
import AiTeammateMessageInput from "../message-input"
import AiTeammateMessagesPanel from "../messages-panel"
import "./style.scss"

export default function AiTeammateThread() {
  const { isFetching } = useMessagesContext()

  return <div className="ai-teammate-thread">
    <AiTeammateMessagesPanel />
    <Divider />
    <AiTeammateFetchingProgress isFetching={isFetching} />
    <AiTeammateMessageInput />
    <div className="ai-teammate-footer">
      {AI_DISCLAIMER}
    </div>
  </div>
}
